import Language from "./Language";
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import {data} from "../helpers/data"



const Card = () => {
  return (
    <Container className="rounded-4 mt-4 p-4" style={{background: "#f48b29"}}>
    <h3 className="text-white my-2">Languages</h3>
    <Row className="g-3 justify-content-center">
    {data.map((lang,index)=>{
        
        return(
        <Col sm={6} md={4} lg={3} key={index} >
            
            <Language {...lang} />
            
        </Col>
        )
       
        
    })}
        
    </Row>
    
    
    </Container>
  )
};

export default Card;
